import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
import { useMemo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomCheckbox } from '../../../../components/Checkbox/Checkbox';
import { useMultiStepFormContext } from '../../../../components/MultiStepPage/MultiStepPage';
import { LabelledList } from '../../../../components/Onboarding/LabelledList';
import Header from '../../../../components/Page/Header';
import { useGlobalStateContext } from '../../../../context/GlobalStateContext/GlobalStateContext';
import { getMerchantPersonalDetailsList } from '../../helpers';
import { pageStyles } from './styles';
export const OrderConfirm = ({ disclaimerChecked, setDisclaimerChecked }) => {
    const { setNextStepLocked, prevStep } = useMultiStepFormContext();
    const { globalState } = useGlobalStateContext();
    const { t: translate } = useTranslation('translation', { keyPrefix: 'ORDER' });
    const handleBack = () => {
        setNextStepLocked?.(false);
        prevStep();
    };
    const { merchantPersonalDetailsList } = useMemo(() => {
        const { merchant } = globalState;
        return {
            merchantPersonalDetailsList: getMerchantPersonalDetailsList(merchant, translate),
        };
    }, [globalState.merchant]);
    useEffect(() => {
        setNextStepLocked?.(!disclaimerChecked);
    }, [disclaimerChecked]);
    return (_jsxs(Box, { sx: pageStyles, children: [_jsx(Header, { title: translate('REVIEW.TITLE'), subtitle: translate('REVIEW.SUBTITLE'), goBackButton: true, goBackHandler: handleBack }), _jsx(Box, { className: 'content', children: _jsxs(Box, { className: 'info', children: [_jsxs(Box, { children: [_jsx(Typography, { variant: 'h2', children: translate('REVIEW.ABOUT_YOU_TITLE') }), _jsx(LabelledList, { list: merchantPersonalDetailsList })] }), _jsx("hr", { "aria-hidden": true }), _jsxs(Box, { children: [_jsx(Typography, { variant: 'h2', children: translate('REVIEW.DISCLAIMER_TITLE') }), _jsxs(Box, { className: 'disclaimer', children: [_jsx(CustomCheckbox, { ariaLabel: translate('REVIEW.CHECKBOX_DISCLAIMER'), isChecked: disclaimerChecked, onChange: () => setDisclaimerChecked?.(!disclaimerChecked) }), _jsx(Typography, { children: translate('REVIEW.DISCLAIMER_CONTENT') })] })] })] }) })] }));
};
